module.exports = __webpack_public_path__ + "videos/engagement-monitoring.4fa4d77.mp4";